export { default as InStockIcon } from "./InStockIcon";
